import { isEmpty, isNil } from 'ramda'

import { Callback } from 'types/utils'

export const pause = async (ms?: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export const delay = async (fn: () => void, ms: number) => {
  await pause(ms)
  await fn()
}

export const debounce = <T>(
  callback: Callback<T, void>,
  ms: number,
  immediate: boolean
) => {
  let timeout: number | null
  return (...args: T[]) => {
    const context = this
    const callNow = immediate && !timeout

    const later = function () {
      timeout = null
      if (!immediate) callback.apply(context, args)
    }

    if (timeout) {
      window.clearTimeout(timeout)
    }
    timeout = window.setTimeout(later, ms)

    if (callNow) callback.apply(context, args)
  }
}

export const uniqueId = () => `_${Math.random().toString(36).substr(2, 9)}`

const gradients = [
  ['#00CC9E', '#06B3D8'],
  ['#157AFB', '#0AD1BD'],
  ['#BD46CC', '#FC4A7E'],
  ['#3023AE', '#C86DD7'],
  ['#157AFB', '#0750A8'],
  ['#77D447', '#159F5D'],
  ['#FBD760', '#FE8540'],
  ['#D52A45', '#E86A3D'],
  ['#B0D63C', '#79A620'],
  ['#7391C9', '#57B2E7'],
  ['#989AA7', '#466171'],
  ['#8483C6', '#3D44A6'],
]

export const getRandomGradient = () => {
  return gradients[Math.floor(Math.random() * gradients.length)]
}

export const replaceWith = (
  str: string,
  searchValue: string,
  replaceValue: string
) => {
  return str.replace(new RegExp(`${searchValue}`, 'g'), replaceValue)
}

export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const copyToClipboard = (str: string) => {
  const el = document.createElement('textarea')
  el.value = str
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isEmptyOrNil = (value: any): value is null | undefined =>
  isNil(value) || isEmpty(value)
